export default "__VITE_ASSET__DdwtPVnC__"